<script setup lang="ts">
defineProps({
    title: { type: String, default: undefined },
    subTitle: { type: String, default: undefined },
});
</script>

<template>
    <BasePage>
        <BasePageTitle v-if="title" :title="title" :sub-title="subTitle" />
        <BaseVerticalStack as="section">
            <slot />
        </BaseVerticalStack>
    </BasePage>
</template>
